function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37",
  transform: "translate(-1062.097 -873.41)"
}, React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M1081.513,915.722l-3.738-8.182-4.22,7.944Z",
  transform: "translate(-7.146 -21.286)",
  fill: "#4b4b4b"
}), React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M1079.373,894.634H1062.1l7.087-15.825-2.309-4.536,1.694-.863,1.613,3.169,1.187-2.651,1.735.777-1.814,4.051Zm-14.341-1.9h11.24l-5.979-11.748Z",
  transform: "translate(0 0)",
  fill: "#4b4b4b"
}));

var SvgCampIcon = function SvgCampIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17.275,
    height: 21.224,
    viewBox: "0 0 17.275 21.224",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCampIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camp-icon.45ae45eb.svg";
export { ForwardRef as ReactComponent };